import { css, keyframes } from 'styled-components';

const flipInX = keyframes`
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }

  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }

  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }

  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
    opacity: 1;
  }

  to {
    transform: perspective(400px);
    opacity: 1;
  }
`;

export const flipInXMixin = css`
  opacity: 0;

  ${({ $animate, $animateDelay = 0 }) => $animate && css`
    backface-visibility: visible !important;
    animation: ${flipInX} 0.4s ease-out forwards ${$animateDelay}ms;
  `}
`;

const fadeInUp = keyframes`
  0% {
    transform: translateY(5px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const fadeInUpMixin = css`
  transform: translateY(5px);
  opacity: 0;

  ${({ $animate, $animateDelay = 0 }) => $animate && css`
    animation: ${fadeInUp} 0.4s ease-out forwards ${$animateDelay}ms;
  `}
`;

const zoomIn = keyframes`
  0% {
    transform: scale(1.05);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

export const zoomInMixin = css`
  transform: scale(0);
  opacity: 0;

  ${({ $animate, $animateDuration = 400, $animateDelay = 0 }) => $animate && css`
    animation: ${zoomIn} ${$animateDuration}ms ease-out forwards ${$animateDelay}ms;
  `}
`;

const zoomInSlightly = keyframes`
  0% {
    transform: rotate(-2deg);
    opacity: 0;
  }
  100% {
    transform: rotate(0);
    opacity: 1;
  }
`;

export const zoomInSlightlyMixin = css`
  transform: rotate(-4deg);
  opacity: 0;

  ${({ $animate, $animateDuration = 400, $animateDelay = 0 }) => $animate && css`
    animation: ${zoomInSlightly} ${$animateDuration}ms ease-out forwards ${$animateDelay}ms;
  `}
`;
